export default __webpack_public_path__ + "static/media/local_pharmacy-24px.7e5c0d9a.svg";